import React, { useMemo, useEffect } from 'react'
import { Form, Button, Input, InputNumber, Row, Col, Divider, Popconfirm } from 'antd'
import SubItems from './SubItems'
import './style.less'
import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'
import { QcType } from '@pages/task/quality-check-reexamine-detail/constant'

import { translateToFormValues, translateToDataValues } from '../utils'

const initialValue = {
  'name': '',
  'type': QcType.moc,
  'items': [
    {
      'moduleName': '',
      'name': '',
      'scoreRangeMax': 10,
      'description': '',
      'subItems': [
        {
          'scoreRangeMin': undefined,
          'scoreRangeMax': undefined,
          'description': '',
        },
      ],
    },
  ],
}

const CreateEditMoc = ({ qcId, qcPlanDetail, onSave }: { qcId: number | null, qcPlanDetail: AIQualityCheckPlanDetailItem | null, onSave: (data: AIQualityCheckPlanDetailItem) => void }) => {
  const [form] = Form.useForm()
  const onFinish = (values) => {
    const newValues = translateToDataValues(values)
    onSave(newValues)
  }
  useEffect(() => {
    if (qcId && qcPlanDetail) {
      form.setFieldsValue(translateToFormValues(qcPlanDetail))
    }
  }, [qcId, qcPlanDetail])

  // 处理赋分值变化，清空对应的评分细则
  const handleScoreRangeMaxChange = (value: number | null, fieldPath: (string | number)[]) => {
    if (value !== null) {
      // 清空对应评分细则的scoreRangeMin和scoreRangeMax
      const subItemsPath = [...fieldPath.slice(0, -1), 'subItems']
      const currentSubItems = form.getFieldValue(subItemsPath) || []
      currentSubItems.forEach((_: any, index: number) => {
        form.setFieldValue([...subItemsPath, index, 'scoreRangeMin'], undefined)
        form.setFieldValue([...subItemsPath, index, 'scoreRangeMax'], undefined)
      })
    }
  }
  return (
    <div className="scheme-create-moc-form-container">
      <Form
        form={form}
        onFinish={onFinish}
        name="moc-form"
        initialValues={translateToFormValues(initialValue)}
      >
        <Form.Item hidden label="方案ID" name="id">
          <Input />
        </Form.Item>
        <Form.Item label="方案类型" name="type" className="moc-form-primary-item">
          <Button type="dashed" size="small" style={{ borderColor: '#1890ff', color: '#1890ff' }}>
            #能力评分
          </Button>
        </Form.Item>

        <Row style={{ width: '100%' }}>
          <Col span={10}>
            <Form.Item label="方案名称" name="name" className="moc-form-primary-item" rules={[{ required: true, message: '请输入方案名称' }]}>
              <Input maxLength={30} placeholder="请输入方案名称" />
            </Form.Item>
          </Col>
        </Row>

        <Form.List name="nodeResults">
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => (
                <div key={field.key}>
                  <div key={field.key}>
                    {/* 板块输入框和按钮放在同一行 */}
                    <Row style={{ width: '100%' }}>
                      <Col span={6}>
                        <Form.Item
                          className="moc-form-primary-item"
                          label="板块"
                          name={[field.name, 'moduleName']}
                          rules={[{ required: true, message: '请输入板块名称' }]}
                        >
                          <Input maxLength={30} placeholder="请输入板块名称" />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Row>
                          <Col>
                            <Form.List name={[field.name, 'items']}>
                              {(innerFields, { add: addInner }) => (
                                <Form.Item>
                                  <Button
                                    type="primary"
                                    onClick={() => addInner({
                                      'name': '',
                                      'scoreRangeMax': 10,
                                      'description': '',
                                      'subItems': [
                                        {
                                          'scoreRangeMin': undefined,
                                          'scoreRangeMax': undefined,
                                          'description': '',
                                        },
                                      ],
                                    })}
                                    style={{ marginLeft: 8 }}
                                  >
                                    新建评分项
                                  </Button>
                                </Form.Item>
                              )}
                            </Form.List>
                          </Col>
                          <Col>
                            {
                              fields.length > 1 && (
                                <Form.Item wrapperCol={{ span: 3 }}>
                                  <Popconfirm className="ml10" title="确认需要删除板块吗？" onConfirm={() => remove(field.name)}>
                                    <Button
                                      style={{ marginLeft: 8 }}
                                    >
                                      删除板块
                                    </Button>
                                  </Popconfirm>
                                </Form.Item>
                              )
                            }
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {/* 评分项列表 */}
                    <Form.List name={[field.name, 'items']}>
                      {(innerFields, { remove: removeInner }) => (
                        <>
                          {innerFields.map((innerField, innerIndex) => (
                            <div key={innerField.key}>
                              <div className="moc-form-item-score" key={innerField.key}>
                                <Form.Item
                                  className="moc-form-primary-item"
                                  label={`评分项${innerIndex + 1}`}
                                  name={[innerField.name, 'name']}
                                  rules={[{ required: true, message: '请输入评分项' }]}
                                >
                                  <Input maxLength={100} placeholder="请填写评分项名称，即此项需要为哪项场景/能力/流程进行检测与评分" />
                                </Form.Item>
                                <Form.Item
                                  style={{ marginLeft: 20 }}
                                  label="赋分"
                                  rules={[{ required: true, message: '请输入赋分' }]}
                                  name={[innerField.name, 'scoreRangeMax']}
                                >
                                  <InputNumber
                                    min={0}
                                    max={20}
                                    onChange={(value) => handleScoreRangeMaxChange(value, ['nodeResults', field.name, 'items', innerField.name, 'scoreRangeMax'])}
                                  />
                                </Form.Item>
                                <Form.Item style={{ width: 50, textAlign: 'right' }}>
                                  {
                                    innerFields.length > 1 && (
                                      <Popconfirm title="确认需要删除评分项吗？" onConfirm={() => removeInner(innerField.name)}>
                                        <Button
                                          type="link"
                                        >
                                          删除
                                        </Button>
                                      </Popconfirm>
                                    )
                                  }
                                </Form.Item>
                              </div>
                              <div className="moc-form-secondary-item">
                                <Form.Item colon={false} label={<span className="description-title">具体描述</span>} style={{ marginLeft: -10, width: '100%', marginBottom: 10 }} name={[innerField.name, 'description']} rules={[{ required: true, message: '请输入具体描述' }]}>
                                  <Input maxLength={500} placeholder="请在此具体描述需要检测与评分的场景/能力/流程，描述越详细，模型效果越好" />
                                </Form.Item>
                                <div style={{ width: 55 }} />
                              </div>
                              <SubItems field={field} innerField={innerField} form={form} />
                            </div>
                          ))}
                        </>
                      )}
                    </Form.List>
                  </div>
                  <Divider />
                </div>
              ))}

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  type="primary"
                  onClick={() => add({
                    'moduleName': '',
                    'items': [
                      {
                        'name': '',
                        'scoreRangeMax': 10,
                        'description': '',
                        'subItems': [
                          {
                            'scoreRangeMin': undefined,
                            'scoreRangeMax': undefined,
                            'description': '',
                          },
                        ],
                      },
                    ],
                  })}
                >
                  新建板块
                </Button>
                <Form.Item style={{ marginLeft: 10 }}>
                  <Button type="primary" htmlType="submit">
                    保存方案
                  </Button>
                </Form.Item>
              </div>
            </>
          )}
        </Form.List>
      </Form>
    </div>
  )
}

export default CreateEditMoc
